const Footer = () => {
  const menuItems = [
    { text: 'Help', href: 'https://doc.glytoucan.org/en/user_manual' },
    {
      text: 'Terms and conditions',
      href: 'https://doc.glytoucan.org/en/Terms-and-Conditions',
    },
    { text: 'Site policy', href: 'https://doc.glytoucan.org/en/site_policy' },
    // { text: 'Contact us', href: 'mailto:support@glycosmos.org' },
  ];

  return (
    <footer className="flex flex-col space-y-8 bg-stone-100 px-2 pb-16 pt-8 md:pt-12">
      <div className="flex flex-col items-center justify-center gap-4 md:flex-row">
        {menuItems.map(item => (
          <div
            key={item.text}
            className="w-full text-center text-stone-600 md:w-52"
          >
            <a
              className="inline-block w-full rounded-md px-4 py-2 hover:bg-stone-400 hover:text-white md:w-fit"
              href={item.href}
            >
              {item.text}
            </a>
          </div>
        ))}
      </div>
      <div className="text-center text-stone-600">
        &copy; 2023-2026 GlyTouCan
      </div>
    </footer>
  );
};

Footer.displayName = 'Footer';

export { Footer };
